import React, { useState } from "react";
import { useI18n } from "../../i18n";

/**
 * iter71 CORTE 2.3 — Chip de sistema colapsable para solicitudes de llamada.
 * Corte 4-D3 — Textos localizados vía i18n (idioma del propietario).
 */
export const isCallRequestMsg = (m) =>
  !!m?.is_call_request ||
  (typeof m?.message === "string" && m.message.startsWith("📞 Solicita"));

export const CallRequestChip = ({ msgs }) => {
  const { t: tr, lang } = useI18n();
  const [open, setOpen] = useState(false);
  if (!msgs || msgs.length === 0) return null;
  const last = msgs[msgs.length - 1];
  const fmtTime = (iso) => {
    try { return new Date(iso).toLocaleTimeString(lang, { hour: "2-digit", minute: "2-digit" }); }
    catch { return ""; }
  };
  return (
    <div className="flex justify-center my-2">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="px-3 py-1.5 rounded-full text-xs font-semibold bg-white/10 text-slate-300 border border-white/15 hover:bg-white/15"
        style={{ backdropFilter: "blur(6px)" }}
        data-testid="call-request-chip"
      >
        📞 {tr("call_chip.title")} · {msgs.length} {msgs.length === 1 ? tr("call_chip.attempt") : tr("call_chip.attempts")}
        {open && (
          <span className="block mt-1 font-normal opacity-75" data-testid="call-request-chip-detail">
            {tr("call_chip.last_attempt")} {fmtTime(last.created_at)}
          </span>
        )}
      </button>
    </div>
  );
};

export default CallRequestChip;
